import { SelectableButtonsProps } from '@src/components/sco/SelectableButtons'
import { LuBriefcaseBusiness, LuHammer, LuHandshake, LuMessageCircleQuestion, LuUsers } from 'react-icons/lu'

// colorHexCode values mirror the matching category in group-request-types.ts:
//   cofounder→cofounder, advisor→advisor, talent→talent (exact),
//   peer→goal (neutral catch-all), service-provider→talent (hire outside help).
export const userRoles = [
  { key: 'cofounder', title: 'Co-founder', icon: LuUsers, colorHexCode: '#872341' },
  { key: 'advisor', title: 'Advisor', icon: LuMessageCircleQuestion, colorHexCode: '#4A47A3' },
  { key: 'peer', title: 'Peers', icon: LuHandshake, colorHexCode: '#5F7495' },
  { key: 'talent', title: 'Talent', icon: LuHammer, colorHexCode: '#46B5D1' },
  { key: 'service-provider', title: 'Service Provider', icon: LuBriefcaseBusiness, colorHexCode: '#46B5D1' },
  // { key: 'customers', title: 'Customers', icon: LuShoppingCart, colorHexCode: '#BE4444' }, // → get-customers
  // { key: 'investor', title: 'Investor', icon: LuDollarSign, comingSoon: true, colorHexCode: '#38908A' }, // → funding
]

export const memberMatchUserRoles = userRoles.filter(x =>
  ['cofounder', 'advisor', 'peer', 'talent'].includes(x.key)
)

export const memberMatchUserRolesSelectableButtonOptions: SelectableButtonsProps['options'] =
  memberMatchUserRoles.map(userRole => ({
    key: userRole.key,
    title: userRole.title,
    selectableButtonProps: {
      activeColor: userRole.colorHexCode,
      iconPlacement: 'top',
      icons: {
        default: userRole.icon,
        selected: userRole.icon,
      },
      buttonProps: {
        flexGrow: 1,
        paddingY: 4,
        borderWidth: '1px',
        _hover: {
          backgroundColor: userRole.colorHexCode,
          borderColor: userRole.colorHexCode,
          color: 'white',
        },
      },
    },
  }))
